<template>
  <div>
    <b-card class="createdReceiptsCard">
      <template slot="header">
        <b-card-title>
          <strong>{{title}}</strong>
        </b-card-title>
        <p class="card-category my-4">{{subTitle}}</p>
        <b-form inline class="pull-right">
          <label class="mr-sm-2">Per page</label>
          <b-form-select v-model="perPage" :options="pageOptions" />
        </b-form>
      </template>
      <template slot="default">
        <b-table
          show-empty
          :items="loadPage"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
        >
          <template slot="actions" slot-scope="row">
            <b-link :href="`https://view.quickreceipts.co/?id=${row.item.id}`" target="_blank"><i class="fa fa-link" /></b-link>
          </template>
        </b-table>
        <b-row>
          <b-col>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalReceipts"
              :per-page="perPage"
              align="center"
              class="my-0"
            />
          </b-col>
        </b-row>
      </template>
      <b-loading :loading="loading" />
    </b-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  data() {
    return {
      title: "Created Receipts",
      subTitle: "A rolling history of the receipts generated with your API Keys",
      processing: false,
      currentPage: 1,
      perPage: 10,
      pageOptions: [
        10,
        20,
        30
      ],
      fields: [
        {
          key: 'id', label: 'Receipt ID',
          sortable: false,
        },
        {
          key: 'generatedAt',
          sortable: true,
        },
        {
          key: 'paymentMethod',
          sortable: false,
        },
        {
          key: 'total_amount',
          sortable: true,
        },
        {
          key: 'actions', label: '',
          sortable: false,
        }
      ],
      sortBy: 'generatedAt',
      sortDesc: false,
      sortDirection: 'desc',
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'loading',
      'totalReceipts',
    ]),
  },
  methods: {
    loadPage() {
      return new Promise((resolve, reject) => {
        const {subscription_plan = 'developer'} = this.user
        const payload = {
          page: this.currentPage,
          limit: this.perPage,
          sortBy: this.sortBy,
          sortDesc: this.sortDesc,
          plan: subscription_plan,
        }
        this.$store.dispatch('loadReceipts', payload).then(({data}) => {
          const {count, receipts} = data
          resolve(receipts.map((item) => ({
            id: item.id,
            generatedAt: moment(item.timestamp).toDate(),
            paymentMethod: item.payment.method,
            total_amount: '$' + Number(item.total_amount).toFixed(2),
          })))
        })
      })
    }
  },
  components: {
  }
}
</script>
<style lang="scss">
.createdReceiptsCard {
}
</style>
